module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-800.bc7114ea.svg";